import { useSyncExternalStore } from 'react'

/**
 * THE RAIL WITHOUT ITS SECOND LINE — owner, 2026-11-04: 設計一個 concise button 的 toggle button. 這個按鈕可以用來切換
 * 是否要預覽 Agent 最後一個訊息 … 在不要預覽的時候呢, 可以看到更多的 agent 的數量.
 *
 * One switch, two readers: the button in the rail's header (ConciseButton) and the rows (Sidebar → AgentRowView). A
 * module store rather than App state, so flipping it draws the rail and the button and nothing else.
 *
 * KEPT ON THIS DEVICE, like the theme beside it: a phone may want the short list while a wide desktop rail keeps the
 * previews. Another window of the app on this device follows through the `storage` event, which fires in every other
 * same-origin document.
 */
const KEY = 'wt_rail_concise'

function stored(): boolean {
  try {
    return localStorage.getItem(KEY) === '1'
  } catch {
    // Storage unavailable (private mode, disabled): the rail shows its previews, as it always did.
    return false
  }
}

let concise = stored()
const listeners = new Set<() => void>()

export function setRailConcise(next: boolean): void {
  if (next === concise) return
  concise = next
  try {
    localStorage.setItem(KEY, next ? '1' : '0')
  } catch {
    // Non-fatal: the choice holds until the page is reloaded.
  }
  for (const fn of listeners) fn()
}

function subscribe(fn: () => void): () => void {
  listeners.add(fn)
  const fromAnotherWindow = (e: StorageEvent) => {
    if (e.key !== KEY && e.key !== null) return
    concise = stored()
    fn()
  }
  window.addEventListener('storage', fromAnotherWindow)
  return () => {
    listeners.delete(fn)
    window.removeEventListener('storage', fromAnotherWindow)
  }
}

/** True while the rail is concise: one line an agent, no last message under the name. */
export function useRailConcise(): boolean {
  return useSyncExternalStore(subscribe, () => concise)
}
